import gql from 'graphql-tag';
import { graphMutation, graphQuery } from '@services/commService';

export const createEntity = async (info) => {
  const { name, description, surveySchema } = info;
  const mutation = gql`
  mutation CreateMentorForm($name: String, $description: String, $surveySchema: JSON) {
    createdEntity: createMentorForm(
      name: $name,
      description: $description,
      surveySchema: $surveySchema
    ) {
        id
        description
        name
        surveySchema
        createdBy
        createdAt
        updatedAt
      }
    }
  `;
  return await graphMutation(mutation, {
    name,
    description,
    surveySchema: surveySchema || null,
  });
};

export const editEntity = async (info) => {
  const { name, description, surveySchema } = info;
  const mutation = gql`
  mutation ModifyMentorForm($id: String, $name: String, $description: String, $surveySchema: JSON) {
    modifyMentorForm(
      id: $id,
      name: $name,
      description: $description,
      surveySchema: $surveySchema
    ) {
        id
        description
        name
        surveySchema
        createdBy
        createdAt
        updatedAt
      }
    }
  `;
  return await graphMutation(mutation, {
    id: info.id,
    name,
    description,
    surveySchema: surveySchema || null,
  });
};

export const deleteEntity = async (id) => {
  const mutation = gql`
  mutation DeleteMentorForm($id: String!) {
    deleteMentorForm(id: $id) {
      name
    }
  }
  `;

  return await graphMutation(mutation, { id });
};

export const loadEntity = async (id) => {
  const query = gql`
  query MentorForm($id: String) {
    entity: mentorForms(id: $id) {
      id
      name
      createdBy
      createdAt
      updatedAt
      description
      surveySchema
    }
  }
  `;
  return await graphQuery(query, false, { id });
};
